export default function BrandMark({ compact = false }) {
  return (
    <div className={`brand-mark${compact ? ' brand-mark-compact' : ''}`}>
      <img
        src="/rebelity-payroll-engine-icon.png"
        alt=""
        width={compact ? 36 : 48}
        height={compact ? 36 : 48}
      />
      <div className="brand-mark-text">
        <span className="brand-mark-name">Rebelity Payroll</span>
        <span className="brand-mark-sub">Engine</span>
      </div>
    </div>
  );
}
